<template>
  <div class="pages-vacancies">
    <BundlesPage />
  </div>
</template>

<style scoped lang="scss">
.pages-vacancies {
  padding-bottom: em(185);

  @include media-breakpoint-down(sm) {
    padding-bottom: em(95);
  }

  @include bundles-constructor-section {
    &:nth-child(2) {
      margin-bottom: em(112);

      @include media-breakpoint-down(sm) {
        margin-bottom: em(65);
      }
    }
  }
}
</style>
